<template>
  <div class='mainContainer'>
    <div class='nav'>
      <div class='navContainer' style='width: 250px'>
        <p>所属供应商：</p>
        <el-select v-model='fleetName' filterable size='mini' style='width:150px' placeholder='请选择'>
          <el-option v-for='item in fleetOption' :key='item.id' :label='item.name'
                     :value='item.name' />
        </el-select>
      </div>
      <div class='navContainer' style='width: 230px'>
        <p>绑定司机：</p>
        <el-input v-model='driverName' size='mini' style='width:150px' placeholder='请输入绑定司机' />
      </div>
      <div class='navContainer' style='width: 210px'>
        <p>车牌号：</p>
        <el-input v-model='license' size='mini' style='width:150px' placeholder='请输入车牌号' />
      </div>
      <div class='navContainer' style='width: 230px'>
        <p>车辆状态：</p>
        <el-select v-model='isEnable' filterable size='mini' style='width:150px' placeholder='请选择'>
          <el-option v-for='item in carStateOption' :key='item.label' :label='item.label'
                     :value='item.value' />
        </el-select>
      </div>
      <div class='navContainer' style='width: 230px'>
        <p>出车状态：</p>
        <el-select v-model='status' filterable size='mini' style='width:150px' placeholder='请选择'>
          <el-option v-for='item in carOption' :key='item.label' :label='item.label'
                     :value='item.value' />
        </el-select>
      </div>
      <div class='navBtn'>
        <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
        <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
        <el-button size='small' type='primary' @click='addBtn'>新增</el-button>
      </div>
    </div>
    <div class='content'>
      <div class='tableContainer'>
        <el-table
          v-loading='tableLoad'
          :data='TableDatas'
          style='width: 100%'
          border
          stripe
          :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
        >
          <el-table-column label='序号' align='center' width='50px' type='index' />
          <el-table-column prop='fleetName' label='所属供应商' width='150' align='center' />
          <el-table-column prop='license' label='车牌号' align='center' />
          <el-table-column prop='colour' label='车牌号颜色' align='center'>
            <template slot-scope='scope'>{{ colourFormat(scope.row.colour) }}</template>
          </el-table-column>
          <!-- <el-table-column prop="brand" label="品牌" align="center"/>
          <el-table-column prop="model" label="型号" align="center"/>
          <el-table-column prop="engine" label="发动机号" align="center"/> -->
          <el-table-column prop='driverName' label='绑定司机' align='center' />
          <el-table-column prop='checkMax' label='最大托运数量' align='center' />
          <el-table-column prop='status' label='出车状态' align='center'>
            <div slot-scope='scope'>{{ getCar(scope.row.status) }}</div>
          </el-table-column>
          <el-table-column prop='isEnable' label='车辆状态' align='center' width='120'>
            <div slot-scope='scope'>{{ getState(scope.row.isEnable) }}</div>
          </el-table-column>
          <el-table-column label='操作' width='440' align='center'>
            <template slot-scope='scope'>
              <div style='align-items:center;'>
                <el-button v-if='scope.row.isEnable' size='mini' type='danger'
                           @click='disableClick(scope.row.id)'>禁用
                </el-button>
                <el-button v-else size='mini' type='primary' @click='enableClick(scope.row.id)'>启用
                </el-button>
                <el-button v-if='scope.row.status!==2' size='mini' type='info'
                           @click='infoClick(scope.row.license,scope.row.id)'>车辆故障
                </el-button>
                <el-button v-else size='mini' type='info' @click='removeClick(scope.row.id)'>解除故障
                </el-button>
                <el-button size='mini' class='searchBtn' type='primary'
                           @click='detailClick(scope.row.id)'>详情
                </el-button>
                <el-button size='mini' type='primary' @click='changeClick(scope.row)'
                           class='yellow-bg'>修改
                </el-button>
                <el-button size='mini' type='info' @click='driverClick(scope.row)'>绑定司机</el-button>
                <el-button size='mini' type='primary' @click='resetClick(scope.row.id)'
                           class='resetBtn'>删除
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class='paginationContainer'>
        <span>共{{ total }}条</span>
        <el-pagination
          background
          :page-sizes='[10, 20, 30, 40]'
          layout='sizes,prev, pager, next,jumper'
          :total='total'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          @prev-click='contractCurrentChange'
          @next-click='contractCurrentChange'
        />
      </div>
    </div>
    <el-dialog :title='dialogTitle' :visible.sync='dialogVisible' width='650px' center
               @close='dialogClose' :close-on-click-modal='false' top='10vh'>
      <div class='depart'>
        <el-form :model='userData' label-width='120px' :rules='rules' ref='ruleForm'>
          <div-border label='基础信息' prop='basic' divStyle='margin-top: 20px'>
            <el-form-item label='所属供应商：' prop='fleetName' style='margin-top: 15px'>
              <el-select v-model='userData.fleetName' size='mini' filterable style='width:80%'
                         placeholder='请选择供应商' value-key='id' @change='driverChangeData'>
                <el-option v-for='item in teamOption' :key='item.id' :label='item.name'
                           :value='item' />
              </el-select>
            </el-form-item>
            <el-row>
              <el-col :span='11'>
                <el-form-item label='车牌号：' prop='license'>
                  <el-input
                    :style="'width:100%'"
                    v-model='userData.license'
                    placeholder='请输入运输车车牌号'
                    autocomplete='off'
                    size='small'
                  />
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label='颜色：' prop='colour' label-width='60px'>
                  <el-select :style="'width:80%'" filterable autocomplete='off' size='small'
                             v-model='userData.colour' placeholder='请选择车牌号(颜色)'>
                    <el-option value='1' label='蓝色'></el-option>
                    <el-option value='2' label='黄色'></el-option>
                    <el-option value='3' label='黑色'></el-option>
                    <el-option value='4' label='白色'></el-option>
                    <el-option value='5' label='其他'></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>


            <el-form-item label='品牌：' prop='brand'>
              <el-input
                :style="'width:80%'"
                v-model='userData.brand'
                placeholder='请输入运输车品牌'
                autocomplete='off'
                size='small'
              />
            </el-form-item>
            <el-form-item label='型号：' prop='model'>
              <el-input
                :style="'width:80%'"
                v-model='userData.model'
                placeholder='请输入运输车型号'
                autocomplete='off'
                size='small'
              />
            </el-form-item>
            <el-form-item label='发动机号：' prop='engine'>
              <el-input
                :style="'width:80%'"
                v-model='userData.engine'
                placeholder='请输入运输车发动机编号'
                autocomplete='off'
                size='small'
              />
            </el-form-item>
            <el-form-item label='档位：' prop='gear'>
              <el-input
                :style="'width:80%'"
                v-model='userData.gear'
                placeholder='请输入运输车档位'
                autocomplete='off'
                size='small'
              />
            </el-form-item>
            <el-form-item label='前后轴承载：' prop='loadAround'>
              <el-input
                :style="'width:80%'"
                v-model='userData.loadAround'
                placeholder='请输入运输车前后轴承载'
                autocomplete='off'
                size='small'
              />
            </el-form-item>
            <el-form-item label='整车尺寸(mm)：' prop='size'>
              <div
                style='display:flex;align-items:center;justify-content: space-between;width:290px;'>
                <el-input
                  :style="'width:85px'"
                  v-model='userData.sizeLong'
                  placeholder='请输入长'
                  autocomplete='off'
                  size='small'
                  @blur='sizeBlur'
                />
                <span style='color: #606266;font-weight: 700;'>X</span>
                <el-input
                  :style="'width:85px'"
                  v-model='userData.sizeWidth'
                  placeholder='请输入宽'
                  autocomplete='off'
                  size='small'
                  @blur='sizeBlur'
                />
                <span style='color: #606266;font-weight: 700;'>X</span>
                <el-input
                  :style="'width:85px'"
                  v-model='userData.sizeHeight'
                  placeholder='请输入高'
                  autocomplete='off'
                  size='small'
                  @blur='sizeBlur'
                />
              </div>
              <span v-if='errorShow' class='el-form-item__error'>请输入运输车长宽高</span>
            </el-form-item>
            <el-form-item label='最大承载：' prop='loadMax'>
              <el-input
                :style="'width:80%'"
                v-model='userData.loadMax'
                placeholder='请输入运输车最大承载'
                autocomplete='off'
                size='small'
              />
            </el-form-item>
            <el-form-item label='最大托运数量：' prop='checkMax'>
              <el-input
                :style="'width:80%'"
                v-model='userData.checkMax'
                placeholder='请输入最大托运数量'
                autocomplete='off'
                size='small'
              />
            </el-form-item>
            <el-form-item label='绑定司机：' prop='driver' style='margin-bottom: 20px'>
              <el-select v-model='userData.driver' size='mini' filterable style='width:80%'
                         placeholder='请先选择所属供应商' value-key='id'>
                <el-option v-for='item in driverOption' :key='item.id' :label='item.name'
                           :value='item' />
              </el-select>
            </el-form-item>
          </div-border>
          <div-border label='上传车辆' prop='car' divStyle='margin-top: 20px'>
            <el-form-item label='车辆照片：' prop='img' style='margin:20px 0 20px 0'>
              <div class='imgUp'>
                <div class='imgLength'><span>{{ userData.img.length }}/5</span></div>
                <el-upload
                  ref='upload'
                  list-type='picture-card'
                  :action='uploadUrl'
                  :data='uploadData'
                  accept='image/png, image/jpeg, image/jpeg, image/bmp, image/gif'
                  :before-upload='beforeAvatarUpload'
                  :on-change='uploadChange'
                  :on-remove='handleRemove'
                  :on-progress='progress'
                  :on-success='success'
                  :file-list='userData.img'
                  :limit=5
                >
                  <div class='img-box'>
                    <i class='el-icon-plus' />
                    <span class='tips'>点击上传车辆照片</span>
                  </div>
                </el-upload>
              </div>
            </el-form-item>
          </div-border>
          <div class='btnContainer'>
            <el-button class='searchBtn' size='medium' :loading='imgIsUpload' @click='addClick'>确定
            </el-button>
            <el-button class='resetBtn' size='medium' @click='dialogClose'>关闭</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog title='详情' :visible.sync='detailDialogVisible' width='650px' center top='8vh'>
      <div class='detail'>
        <div class='baseInfo'>
          <div class='baseInfoTitle'>
            <div class='line' />
            <span>基础信息</span>
            <p :style='getStyle(detailData.isEnable)'>{{ getState(detailData.isEnable) }}</p>
          </div>
          <div class='baseInfoContent'>
            <div class='baseInfoContentItem'>
              <span class='span1'>所属供应商：</span>
              <span>{{ detailData.fleetName }}</span>
            </div>
            <div class='baseInfoContentItem'>
              <span class='span1'>车牌号：</span>
              <span>{{ detailData.license }}</span>
            </div>
            <div class='baseInfoContentItem specialItem'>
              <div class='specialOne'>
                <span class='span1'>品牌：</span>
                <span>{{ detailData.brand }}</span>
              </div>
              <div>
                <span class='span1'>型号：</span>
                <span>{{ detailData.model }}</span>
              </div>
            </div>
            <div class='baseInfoContentItem specialItem'>
              <div class='specialOne'>
                <span class='span1'>发动机号：</span>
                <span>{{ detailData.engine }}</span>
              </div>
              <div>
                <span class='span1'>档位：</span>
                <span>{{ detailData.gear }}</span>
              </div>
            </div>
            <div class='baseInfoContentItem specialItem'>
              <div class='specialOne'>
                <span class='span1'>前后轴继承：</span>
                <span>{{ detailData.loadAround }}</span>
              </div>
              <div>
                <span class='span1'>整车尺寸：</span>
                <span>{{ detailData.sizeLong }}*{{ detailData.sizeWidth }}*{{ detailData.sizeHeight
                  }}</span>
              </div>
            </div>
            <div class='baseInfoContentItem specialItem'>
              <div class='specialOne'>
                <span class='span1'>最大承载：</span>
                <span>{{ detailData.loadMax }}</span>
              </div>
              <div>
                <span class='span1'>最大托运数量：</span>
                <span>{{ detailData.checkMax }}</span>
              </div>
            </div>
            <div class='baseInfoContentItem'>
              <span class='span1'>绑定司机：</span>
              <span>{{ detailData.driverName }}</span>
            </div>
            <div class='baseInfoContentItem'>
              <span class='span1'>照片：</span>
              <div class='imgContainer'>
                <el-image
                  v-for='(item,index) in detailData.img'
                  :key='index'
                  style='width: 100px; height: 100px;margin-right:10px; '
                  :src="baseImgUrl + 'web/attachmentFtp/download?attachmentId='+(item)+'&access_token='+token"
                  :preview-src-list="[baseImgUrl + 'web/attachmentFtp/download?attachmentId='+(item)+'&access_token='+token]"
                  fit='cover'
                />
              </div>
            </div>
          </div>
        </div>
        <div class='operation'>
          <div class='operationTitle'>
            <div class='line' />
            <span>操作信息</span>
          </div>
          <div class='operationTable'>
            <el-table :data='operationData' border>
              <el-table-column label='操作时间' align='center' width='160px'>
                <div slot-scope='scope'>{{ getTime(scope.row.createTime) }}</div>
              </el-table-column>
              <el-table-column prop='operateType' label='操作类型' align='center' />
              <el-table-column prop='operationName' label='操作人' align='center' />
              <el-table-column prop='remark' label='备注' align='center' />
            </el-table>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog title='车辆故障' :visible.sync='faultVisible' width='500px' center @close='faultClose'>
      <div class='fault'>
        <el-form :model='faultData' label-width='90px' :rules='rules2' ref='ruleForms'>
          <el-form-item label='车牌号：' prop='license'>
            <el-input
              :disabled='true'
              :style="'width:100%'"
              v-model='faultData.license'
              placeholder='请输入运输车车牌号'
              autocomplete='off'
              size='small'
            />
            <hr color='#F0F0F2' />
          </el-form-item>
          <el-form-item label='故障描述：' prop='remark'>
            <el-input
              type='textarea'
              :style="'width:100%'"
              v-model='faultData.remark'
              placeholder='请输入运输车故障大致的描述'
              autocomplete='off'
              size='small'
            />
          </el-form-item>
          <el-form-item label='上传照片：' prop='img' style='margin-bottom:0'>
            <div class='imgUp'>
              <div class='imgLength'><span>{{ faultData.img.length }}/5</span></div>
              <el-upload
                ref='uploads'
                list-type='picture-card'
                :action='uploadUrl'
                :data='uploadData'
                accept='image/png, image/jpeg, image/jpeg, image/bmp, image/gif'
                :before-upload='beforeAvatarUpload'
                :on-change='uploadChange1'
                :on-remove='handleRemove1'
                :on-progress='progress1'
                :on-success='success1'
                :file-list='faultData.img'
                :limit=5
              >
                <div class='img-box'>
                  <i class='el-icon-plus' />
                  <span class='tips'>点击上传照片</span>
                </div>
              </el-upload>
            </div>
          </el-form-item>
          <div class='btnContainer'>
            <el-button class='searchBtn' size='medium' :loading='imgIsUpload' @click='addClick1'>
              确定
            </el-button>
            <el-button class='resetBtn' size='medium' @click='dialogClose1'>关闭</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog title='绑定司机' :visible.sync='driverVisible' width='600px' @close='driverClose'>
      <div class='depart'>
        <el-form :model='driver' v-if='driver.driverType!=1' style='padding:20px 30px 0'
                 ref='formDriver' label-width='110px' :rules='driverRules'>
          <el-form-item prop='driverName' label='司机姓名：'>
            <el-select v-model='driver.driverName' style='width:100%' filterable size='mini'
                       placeholder='请选择司机' value-key='id'>
              <el-option v-for='item in driverOption' :key='item.id' :label='item.name'
                         :value='item' />
            </el-select>
          </el-form-item>
          <div class='btnContainer'>
            <el-button @click='driverAddClick' :loading='imgIsUpload' class='searchBtn'
                       size='small'>确认
            </el-button>
            <el-button @click='driverClose' size='small'>关闭</el-button>
          </div>
        </el-form>
        <div class='detail' v-else>
          <div class='baseInfo'>
            <div class='baseInfoTitle'>
              <div class='line' />
              <span>基础信息</span>
              <p :style="`color:${driver.isEnable?'rgba(51, 136, 255, 1)':'#f78989'}`">
                {{ getState(driver.isEnable) }}</p>
              <span style='display:inline-block;width:65%;text-align:right;'>
                <el-button size='mini' :loading='imgIsUpload' type='primary'
                           @click='unDriverClick(driver)' class='resetBtn'>解绑车辆</el-button>
              </span>
            </div>
            <div class='baseInfoContent'>
              <div class='baseInfoContentItem specialItem'>
                <div class='specialOne'>
                  <span class='span1'>所属供应商：</span>
                  <span>{{ driver.fleetName }}</span>
                </div>
                <div>
                  <span class='span1'>司机姓名：</span>
                  <span>{{ driver.name }}</span>
                </div>
              </div>
              <div class='baseInfoContentItem specialItem'>
                <div class='specialOne'>
                  <span class='span1'>司机类型：</span>
                  <span>{{ getType(driver.type) }}</span>
                </div>
                <div>
                  <span class='span1'>绑定车辆：</span>
                  <span>{{ driver.bindCarName }}</span>
                </div>
              </div>
              <div class='baseInfoContentItem'>
                <span class='span1'>联系手机号：</span>
                <span>{{ driver.phoneNumber }}</span>
              </div>
              <div class='baseInfoContentItem specialItem'>
                <div class='specialOne'>
                  <span class='span1'>性别：</span>
                  <span>{{ getSex(driver.gender) }}</span>
                </div>
                <div>
                  <span class='span1'>年龄：</span>
                  <span>{{ driver.age }}</span>
                </div>
              </div>
              <div class='baseInfoContentItem'>
                <span class='span1'>家庭住址：</span>
                <span>{{ driver.address }}</span>
              </div>
              <div class='baseInfoContentItem'>
                <span class='span1'>身份证号：</span>
                <span>{{ driver.idCard }}</span>
              </div>
              <div class='baseInfoContentItem'>
                <div style='display: flex;'>
                  <span class='span1'>身份证(正反面)：</span>
                  <el-image
                    v-for='(item,index) in driver.cardImg'
                    :key='index'
                    style='width: 100px; height: 100px;margin-right:10px; '
                    :src="baseImgUrl + 'web/attachmentFtp/download?attachmentId='+(item)+'&access_token='+token"
                    :preview-src-list="[baseImgUrl + 'web/attachmentFtp/download?attachmentId='+(item)+'&access_token='+token]"
                    fit='cover' />
                </div>
              </div>
            </div>
          </div>
          <div class='baseInfo' v-if='driver.driverCertificateDoc'>
            <div class='baseInfoTitle'>
              <div class='line' />
              <span>证书信息</span>
            </div>
            <div class='baseInfoContent'>
              <div class='baseInfoContentItem specialItem'>
                <div class='specialOne'>
                  <span class='span1'>驾龄：</span>
                  <span>{{ driver.driverCertificateDoc.age }}</span>
                </div>
                <div>
                  <span class='span1'>驾驶证等级：</span>
                  <span>{{ driver.driverCertificateDoc.level }}</span>
                </div>
              </div>
              <div class='baseInfoContentItem'>
                <div style='display: flex;'>
                  <span class='span1'>驾驶证(正反面)：</span>
                  <el-image
                    v-for='(item,index) in driver.licenseImg'
                    :key='index'
                    style='width: 100px; height: 100px;margin-right:10px; '
                    :src="baseImgUrl + 'web/attachmentFtp/download?attachmentId='+(item)+'&access_token='+token"
                    :preview-src-list="[baseImgUrl + 'web/attachmentFtp/download?attachmentId='+(item)+'&access_token='+token]"
                    fit='cover' />
                </div>
              </div>
              <div class='baseInfoContentItem'>
                <div style='display: flex;'>
                  <span class='span1'>从业资格证(正反面)：</span>
                  <el-image
                    v-for='(item,index) in driver.certificate'
                    :key='index'
                    style='width: 100px; height: 100px;margin-right:10px; '
                    :src="baseImgUrl + 'web/attachmentFtp/download?attachmentId='+(item)+'&access_token='+token"
                    :preview-src-list="[baseImgUrl + 'web/attachmentFtp/download?attachmentId='+(item)+'&access_token='+token]"
                    fit='cover' />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import divBorder from '@/components/divBorder';
  import {
    truckPageList, truckIsEnable, truckAdd,
    truckDelete, truckUpdate, truckDetail,
    truckDocAdd, getHighwayParam, carFaultDcDelete,
    driverSelectDriverByCar, driverDetails, driverVehicle,
    unDriverVehicle,
  } from '@/service/basicfile';
  import { formatDateTime, getSessionStore, removeSpace } from '@/config/mUtils';
  import { baseUrl, baseImgUrl } from '@/config/env';

  export default {
    components: {
      divBorder,
    },
    data() {
      const validateCar = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入车牌号'));
        } else if (!(/[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1}/).test(value)) {
          callback(new Error('请输入正确的车牌号'));
        } else {
          callback();
        }
      };
      return {
        errorShow: false,
        fleetName: '',
        driverName: '',
        license: '',
        isEnable: '',
        status: '',
        fleetOption: [
          {
            id: '',
            name: '全部',
          },
        ],
        carStateOption: [
          {
            value: '',
            label: '全部',
          },
          {
            value: 1,
            label: '启动中',
          },
          {
            value: 0,
            label: '禁用中',
          },
        ],
        carOption: [
          {
            value: '',
            label: '全部',
          },
          {
            value: 0,
            label: '空闲',
          },
          {
            value: 1,
            label: '运输中',
          },
          {
            value: 2,
            label: '故障',
          },
        ],
        tableLoad: false,
        TableDatas: [],
        page: 1,
        size: 10,
        total: 0,
        dialogTitle: '',
        dialogVisible: false,
        userData: {
          fleetId: '',
          driver: '',
          license: '',
          brand: '',//品牌
          model: '',
          engine: '',
          gear: '',
          loadAround: '',
          sizeLong: '',//整车长
          sizeWidth: '',//整车宽
          sizeHeight: '',//整车高
          loadMax: '',
          checkMax: '',//最大托运数量
          img: [],
        },
        rules: {
          fleetName: [
            {
              required: true,
              message: '请选择供应商',
              trigger: 'change',
            },
          ],
          basic: [
            {
              required: true,
              message: ' ',
              trigger: 'blur',
            },
          ],
          colour: [
            {
              required: true,
              message: '请选择车牌号颜色',
              trigger: 'blur',
            },
          ],
          model: [
            {
              required: true,
              message: '请输入运输车型号',
              trigger: 'blur',
            },
          ],
          license: [
            {
              required: true,
              validator: validateCar,
              trigger: 'blur',
            },
          ],
          brand: [
            {
              required: true,
              message: '请输入运输车品牌',
              trigger: 'blur',
            },
          ],
          engine: [
            {
              required: true,
              message: '请输入运输车发动机编号',
              trigger: 'blur',
            },
          ],
          gear: [
            {
              required: true,
              message: '请输入运输车档位',
              trigger: 'blur',
            },
          ],
          loadAround: [
            {
              required: true,
              message: '请输入运输车前后轴承载',
              trigger: 'blur',
            },
          ],
          size: [
            {
              required: true,
              message: ' ',
              trigger: 'blur',
            },
          ],
          loadMax: [
            {
              required: true,
              message: '请输入运输车最大承载量',
              trigger: 'blur',
            },
          ],
          checkMax: [
            {
              required: true,
              message: '请输入最大托运数量',
              trigger: 'blur',
            },
          ],
          img: [
            {
              type: 'array',
              required: true,
              message: '请上传车辆照片',
              trigger: 'blur',
            },
          ],
          car: [
            {
              required: true,
              message: ' ',
              trigger: 'blur',
            },
          ],
        },
        teamOption: [],
        driverOption: [],
        roleOption: [
          {
            value: '普通角色',
            label: '普通角色',
          },
          {
            value: '管理员',
            label: '管理员',
          },
          {
            value: '测试员',
            label: '测试员',
          },
        ],
        departmentOption: [
          {
            value: '财务部',
            label: '财务部',
          },
          {
            value: '市场部',
            label: '市场部',
          },
          {
            value: '市场部',
            label: '市场部',
          },
        ],
        detailDialogVisible: false,
        detailData: '',
        token: getSessionStore('token'),
        operationData: [],
        faultVisible: false,
        faultData: {
          license: '',
          remark: '',
          img: '',
        },
        rules2: {
          remark: [
            {
              required: true,
              message: '请输入故障描述',
              trigger: 'blur',
            },
          ],
          img: [
            {
              type: 'array',
              required: true,
              message: '请上传故障照片',
              trigger: 'blur',
            },
          ],
        },
        baseImgUrl: baseImgUrl + '/',
        uploadUrl: '',
        uploadData: {
          fileType: '1',
        },
        imgIsUpload: false,
        driverVisible: false,   // 绑定司机弹窗显隐控制
        driver: { driverType: 0 },   // 绑定司机数据
        driverRules: {
          driverName: {
            required: true,
            message: '请选择司机',
            trigger: 'change',
          },
        },
      };
    },
    computed: {
      getCar() {
        return function(car) {
          switch (car) {
            case 1:
              return '待开始';
            case 2:
              return '运输中';
            case 3:
              return '车辆故障';
            case 0:
              return '空闲中';
          }
        };
      },
      colourFormat() {
        return function(value) {
          switch (value) {
            case 1:
              return '蓝色';
            case 2:
              return '黄色';
            case 3:
              return '黑色';
            case 4:
              return '白色';
            case 5:
              return '其他';
          }
        };
      },
      getStyle() {
        return (val) => {
          switch (val) {
            case 1:
              return 'color: #3388ff';
            case 0:
              return 'color:#F56C6C;';
          }
        };
      },
      getState() {
        return function(state) {
          switch (state) {
            case 1:
              return '启用';
            case 0:
              return '禁用';
          }
        };
      },
      getType() {
        return function(type) {
          switch (type) {
            case 1:
              return '板车司机';
            case 2:
              return '地跑司机';
          }
        };
      },
      getSex() {
        return function(sex) {
          switch (sex) {
            case 1:
              return '男';
            case 0:
              return '女';
          }
        };
      },
      getTime() {
        return function(time) {
          return formatDateTime(time, 'yyyy-mm-dd hh:ii:ss');
        };
      },
    },
    mounted() {
      this.init();
      this.uploadUrl = baseUrl + '/web/attachmentFtp/upload';
    },
    methods: {
      async init() {
        await this._truckPageList();
        const res = await getHighwayParam();
        if (res.status !== 0) {
          this.$message.error(res.message);
        } else {
          this.fleetOption = [{
            id: '',
            name: '全部',
          }, ...res.data];
          console.log(this.fleetOption);
           this.teamOption = res.data;
        }
      },
      async _truckPageList() {
        this.tableLoad = true;
        const obj = {
          fleetName: this.fleetName,
          driverName: this.driverName,
          license: this.license,
          isEnable: this.isEnable,
          status: this.status,
          rows: this.size,
          page: this.page,
        };
        const res = await truckPageList(obj);
        this.tableLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.TableDatas = res.data.records;
        this.total = res.data.total;
      },
      // 下拉查询赛选未绑定运输车辆的数据
      async _driverSelectDriverByCar(supplierId, rowId) {   //供应商id
        const params = {
          highwayId: supplierId,
        };
        if (rowId) params.carInfoId = rowId;
        let res = await driverSelectDriverByCar(params);
        if (res.status !== 0) return this.$message.error(res.message);
        this.driverOption = res.data.map(item => {
          return {
            name: item.name,
            id: item.id,
          };
        });
      },
      sizeBlur() {
        this.errorShow = !this.userData.sizeLong || !this.userData.sizeWidth || !this.userData.sizeHeight;
      },
      faultClose() {
        this.faultVisible = false;
        this.$refs.uploads.clearFiles();
        this.$refs.ruleForms.resetFields();
      },
      handleRemove1(file, fileList) {
        this.faultData.img = fileList;
      },
      progress1() {
        this.imgIsUpload = true;
      },
      success1(res) {
        this.imgIsUpload = false;
        if (res.status !== 0) this.$message.error('该图片上传失败！');
        this.$message.success(res.message);
        this.imgIsUpload = false;
      },
      handleRemove(file, fileList) {
        this.userData.img = fileList;
      },
      progress() {
        this.imgIsUpload = true;
      },
      success(res) {
        if (res.status !== 0) this.$message.error('该图片上传失败！');
        this.$message.success(res.message);
        this.imgIsUpload = false;
      },
      resetBtn() {
        this.fleetName = '';
        this.driverName = '';
        this.license = '';
        this.isEnable = '';
        this.status = '';
      },
      searchBtn() {
        this.page = 1;
        this._truckPageList();
      },
      async addBtn() {
        this.dialogVisible = true;
        this.dialogTitle = '添加运输车';
        this.errorShow = false;
        this.userData = {
          fleetId: '',
          driver: '',
          num: '',
          type: '',
          model: '',
          colour: '',//车牌号颜色
          engine: '',
          gear: '',
          bearingLoad: '',
          size: {
            lang: '',
            width: '',
            height: '',
          },
          maxLoad: '',
          img: [],
        };
      },
      contractSizeChange(sizes) {
        this.size = sizes;
        this._truckPageList();
      },
      contractCurrentChange(page) {
        this.page = page;
        this._truckPageList();
      },
      async detailClick(id) {
        this.detailDialogVisible = true;
        const res = await truckDetail(id);
        if (res.status !== 0) return this.$message.error(res.message);

        this.detailData = {
          ...res.data,
          img: res.data.carUrl01.split(','),
        };
        this.operationData = res.data.operateRecordList;
      },
      resetClick(id) {
        this.$confirm('确定要删除当前运输车吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const res = await truckDelete(id);
            if (res.status !== 0) {
              return this.$message.error(res.message);
            } else {
              this.$message.success(res.message);
            }
            await this._truckPageList();
          })
          .catch(() => {
          });
      },
      disableClick(id) {
        this.$confirm('确定要禁用当前运输车吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const res = await truckIsEnable(id);
            if (res.status !== 0) {
              return this.$message.error(res.message);
            } else {
              this.$message.success(res.message);
            }
            await this._truckPageList();
          })
          .catch(() => {
          });
      },
      enableClick(id) {
        this.$confirm('确定要启用当前运输车吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const res = await truckIsEnable(id);
            if (res.status !== 0) {
              return this.$message.error(res.message);
            } else {
              this.$message.success(res.message);
            }
            await this._truckPageList();
          })
          .catch(() => {
          });
      },
      infoClick(license, id) {
        this.faultVisible = true;
        this.faultData = {
          id,
          license,
          remark: '',
          img: '',
        };
      },
      removeClick(id) {
        this.$confirm('确定要解除故障吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const res = await carFaultDcDelete(id);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            await this._truckPageList();
          })
          .catch(() => {
          });
      },
      changeClick(item) {
        this._driverSelectDriverByCar(item.fleetId);
        this.dialogVisible = true;
        this.dialogTitle = '修改运输车';
        this.errorShow = false;
        const imgArr = item.carUrl01.split(',');
        const img = [];
        let token = getSessionStore('token');
        let url = '/web/attachmentFtp/download?attachmentId=' + (item) + '&access_token=' + token;
        imgArr.forEach(item => img.push({ url: baseImgUrl + '/web/attachmentFtp/download?attachmentId=' + (item) + '&access_token=' + token }));
        item.colour = item.colour.toString();
        console.log(item);
        this.userData = {
          ...item,
          fleetName: {
            id: item.fleetId,
            name: item.fleetName,
          },
          driver: {
            id: item.driverId,
            name: item.driverName,
          },
          bearingLoad: item.loadAround,
          size: {
            lang: item.sizeLong,
            width: item.sizeWidth,
            height: item.sizeHeight,
          },
          img,
        };
        this._driverSelectDriverByCar(item.fleetId, item.id);
      },
      dialogClose() {
        this.dialogVisible = false;
        this.userData = {
          fleetName: '',
          driver: '',
          license: '',
          type: '',
          model: '',
          engine: '',
          gear: '',
          bearingLoad: '',
          size: {
            lang: '',
            width: '',
            height: '',
          },
          loadMax: '',
          img: [],
        };
        this.$refs.upload.clearFiles();
        this.$refs.ruleForm.resetFields();
      },
      dialogClose1() {
        this.faultVisible = false;
        this.$refs.uploads.clearFiles();
        this.$refs.ruleForms.resetFields();
      },
      addClick() {
        this.userData = removeSpace(this.userData);
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            this.sizeBlur();
            if (this.errorShow) return;
            let str = '';
            this.userData.img.forEach(item => {
              if (!item.response) {

                //正则匹配id
                let Reid = item.url.match(/attachmentId=(.*)&/)[1];
                str += Reid + ',';
              } else {
                str += item.response.data.id + ',';
              }
            });
            str = str[str.length - 1] === ',' ? str.slice(0, str.length - 1) : str;
            this.imgIsUpload = true;
            const obj = {
              id: this.userData.id,
              carUrl01: str,
              fleetId: this.userData.fleetName.id,
              fleetName: this.userData.fleetName.name,
              license: this.userData.license,
              brand: this.userData.brand,
              model: this.userData.model,
              engine: this.userData.engine,
              gear: this.userData.gear,
              loadAround: this.userData.loadAround,
              sizeLong: this.userData.sizeLong,
              sizeWidth: this.userData.sizeWidth,
              sizeHeight: this.userData.sizeHeight,
              loadMax: this.userData.loadMax,
              checkMax: this.userData.checkMax,
              driverId: this.userData.driver.id,
              driverName: this.userData.driver.name,
              colour: this.userData.colour,
            };
            const res = this.dialogTitle === '添加运输车' ? await truckAdd(obj) : await truckUpdate(obj);
            this.imgIsUpload = false;
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this.dialogClose();
            await this._truckPageList();
          } else {
            return false;
          }
        });
      },
      addClick1() {
        this.$refs.ruleForms.validate(async (valid) => {
          if (valid) {
            let str = '';
            this.faultData.img.forEach(item => {
              if (!item.response) {
                //正则匹配id
                let Reid = item.url.match(/attachmentId="(.*)"&/)[1];
                str += Reid + ',';
              } else {
                str += item.response.data.id + ',';
              }
            });
            str = str.slice(0, str.length - 1);
            this.imgIsUpload = true;
            const obj = {
              carId: this.faultData.id,
              license: this.faultData.license,
              remark: this.faultData.remark,
              url01: str,
            };
            const res = await truckDocAdd(obj);
            this.imgIsUpload = false;
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            await this._truckPageList();
            this.dialogClose1();
          } else {
            return false;
          }
        });
      },
      uploadChange1(file, fileList) {
        this.faultData.img = fileList;
        if (Object.keys(file)
          .includes('response')) {
          if (file.response.status !== 0) {
            this.faultData.img.splice(this.faultData.img.indexOf(file), 1);
          }
        }
      },
      beforeAvatarUpload(file) {
        const TypeArr = ['image/jpeg', 'image/png', 'image/bmp', 'image/gif', 'image/jpg'];
        const isJPG = TypeArr.includes(file.type);
        const isLt10M = file.size / 1024 / 1024 < 10;
        if (!isJPG) this.$message.error('上传图片只能为jpg/png/jpeg/bmp/gif格式');
        if (!isLt10M) this.$message.error('上传图片大小不能超过 10MB');
        this.imgIsUpload = true;
        return isJPG && isLt10M;
      },
      uploadChange(file, fileList) {
        this.userData.img = fileList;
        if (Object.keys(file)
          .includes('response')) {
          if (file.response.status !== 0) {
            this.userData.img.splice(this.userData.img.indexOf(file), 1);
          }
        }
      },
      driverChangeData(value) {
        this._driverSelectDriverByCar(value.id);
      },
      // 解绑司机
      async unDriverClick(row) {
        this.$confirm('确定要给当前运输车解绑司机吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            this.imgIsUpload = true;
            const res = await unDriverVehicle(row.bindCarId);
            this.imgIsUpload = false;
            if (res.status !== 0) {
              return this.$message.error(res.message);
            } else {
              this.$message.success(res.message);
            }
            this._truckPageList();
            this.driverClose();
          })
          .catch(() => {
          });
      },
      // 绑定司机 —— 打开弹窗
      async driverClick(row) {
        this.driver.driverType = row.driverType;
        this.driver.id = row.id;
        this.driver.fleetId = row.fleetId;
        if (row.driverType == 1) {
          let res = await driverDetails(row.driverId);
          if (res.status !== 0) return this.$message.error(res.message);
          this.driver = {
            ...res.data,
            cardImg: [],
            licenseImg: [],
            certificate: [],
            driverType: row.driverType,
          };
          if (res.data.cardImg) {
            this.driver.cardImg = res.data.cardImg.split(',');
          }
          if (res.data.driverCertificateDoc) {
            if (res.data.driverCertificateDoc.licenseUrl01) {
              this.driver.licenseImg.push(res.data.driverCertificateDoc.licenseUrl01);
            }
            if (res.data.driverCertificateDoc.licenseUrl02) {
              this.driver.licenseImg.push(res.data.driverCertificateDoc.licenseUrl02);
            }
            if (res.data.driverCertificateDoc.practiceUrl01) {
              this.driver.certificate.push(res.data.driverCertificateDoc.practiceUrl01);
            }
            if (res.data.driverCertificateDoc.practiceUrl02) {
              this.driver.certificate.push(res.data.driverCertificateDoc.practiceUrl02);
            }
          }
          console.log(this.driver);
        } else {
          this._driverSelectDriverByCar(row.fleetId);
        }
        this.driverVisible = true;
      },
      // 绑定司机 —— 关闭弹窗
      driverClose() {
        this.driverVisible = false;
        if (this.driver.driverType != 1) {
          this.$refs.formDriver.resetFields();
          for (let ket in this.driver) {
            this.driver[ket] = '';
          }
        }
      },
      // 绑定司机 —— 确认按钮
      async driverAddClick() {
        this.$refs.formDriver.validate(async (valid) => {
          if (valid) {
            let obj = {
              id: this.driver.id,
              driverId: this.driver.driverName.id,
              fleetId: this.driver.fleetId,
            };
            this.imgIsUpload = true;
            let res = await driverVehicle(obj);
            this.imgIsUpload = false;
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this._truckPageList();
            this.driverClose();
          } else {
            return false;
          }
        });
      },
    },
  };
</script>


<style lang='scss' scoped>
  .mainContainer {
    width: 100%;
    padding: 20px 15px 0 25px;
    background-color: #fff;

    .img-box {
      position: relative;
      width: 150px;
      height: 100px;

      img {
        width: 150px;
        height: 100px;
      }

      .tips {
        position: absolute;
        display: none;
      }

      &:hover .tips {
        display: block;
        position: absolute;
        //bottom:0;
        top: 0;
        left: 0;
        color: #FFF;
        width: 146px;
        z-index: 10;
        height: 148px;
        background: #000;
        opacity: 0.6;
      }
    }

    .line {
      width: 12px;
      height: 32px;
      background-color: rgba(51, 84, 131, 100);
      margin-right: 10px;
    }

    .line + span {
      font-size: 16px;
      color: rgba(51, 84, 131, 100);
      font-weight: 600;
    }

    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      &Container {
        width: 200px;
        display: flex;
        align-items: center;
        margin-right: 5px;
        margin-bottom: 5px;

        p {
          font-size: 14px;
          color: rgba(16, 16, 16, 100);
        }
      }

      &Btn {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }

    .content {
      display: flex;
      flex-direction: column;
      align-items: center;

      .tableContainer {
        margin-top: 15px;
        margin-bottom: 25px;
        width: 100%;

        ::v-deep {
          .el-table .cell {
            padding: 0;
          }

          .el-table th {
            padding: 0;
          }

          .el-table td {
            padding: 0;
          }

          .el-table th > .cell {
            font-weight: 700 !important;
          }
        }
      }

      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        span {
          font-size: 13px;
        }
      }
    }

    .fault {
      width: 100%;
      padding: 10px;
      max-height: 70vh;
      overflow: auto;

      .imgUp {
        display: flex;
        flex-direction: column;

        .imgLength {
          display: flex;
          align-items: center;
          width: 100%;

          span {
            margin-left: auto;
            color: rgb(183, 183, 183);
            font-size: 16px;
          }
        }
      }

      ::v-deep {
        .el-form-item__label {
          font-weight: 700;
        }

        .el-form-item {
          margin-bottom: 15px;
        }

        .el-input__inner {
          border: none;
        }

        .el-form-item__label {
          padding: 0;
        }

        .el-form-item__content {
          position: relative;
        }
      }

      hr {
        margin: 0;
        position: absolute;
        width: 100%;
        bottom: 5px;
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 20px 0 10px 0;

        button {
          margin: 0 15px;
        }
      }
    }

    .depart {
      width: 100%;
      padding: 0 10px;
      max-height: 70vh;
      overflow: auto;

      .imgUp {
        display: flex;
        flex-direction: column;

        .imgLength {
          display: flex;
          align-items: center;
          width: 100%;

          span {
            margin-left: auto;
            color: rgb(183, 183, 183);
            font-size: 16px;
          }
        }
      }

      ::v-deep {
        .el-form-item__label {
          font-weight: 700;
        }

        .el-form-item {
          margin-bottom: 15px;
        }

        //.el-input__inner{
        //  border: none;
        //}
        .el-form-item__label {
          padding: 0;
        }

        .el-form-item__content {
          position: relative;
        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 20px 0 10px 0;

        button {
          margin: 0 15px;
        }
      }
    }

    .permissions {
      width: 100%;
      padding: 20px 10px 20px 50px;

      .name {
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        span {
          color: #2F1010;
        }
      }

      .content1 {
        p {
          color: #2F1010;
        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 30px 0 10px 0;

        button {
          margin: 0 15px;
        }
      }
    }

    .detail {
      width: 100%;
      padding: 10px 0 20px 20px;
      max-height: 70vh;
      overflow: auto;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;

          &Item {
            margin-bottom: 15px;

            .imgContainer {
              display: flex;
              align-items: center;
            }

            .span1 {
              font-weight: 700;
            }

            span {
              font-size: 14px;
            }

            .specialOne {
              width: 50%;
            }
          }

          .specialItem {
            display: flex;
          }
        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        ::v-deep {
          .el-table td, .el-table th {
            padding: 0;
          }

          .cell {
            font-size: 10px;
            padding: 0;
          }
        }

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding: 0 20px;
        }
      }
    }

    ::v-deep {
      .el-dialog__header {
        padding: 9px 20px 9px;
        background: #335483;
      }

      .el-dialog__title {
        line-height: 24px;
        font-size: 14px;
        color: #FFFFFF;
      }

      .el-dialog__headerbtn {
        top: 9px;
      }

      .el-dialog__headerbtn .el-dialog__close {
        color: #fff;
        font-size: 25px;
      }

      .el-dialog__body {
        padding: 0;
      }
    }
  }
</style>
